import _ from 'underscore';
import { StateStore } from '@bingads-webui/state-store';
import { History, Location } from 'history';

export interface IScope {
  values: {
    aid: string | number;
    cid: string | number;
    uid: string | number | null;
    adGroupId: string | number | null;
    campaignId: string | number | null;
  };
  location: {
    hash: string;
    pathname: string;
    search: string;
  };
}

interface IScopeState {
  scope?: IScope;
}

export const scopeStore = new StateStore<IScopeState>({});

interface IRouteState {
  history?: History;
  location?: Location;
}
export const routeStore = new StateStore<IRouteState>({});

interface II18nState {
  i18n?: any;
}
export const i18nStore = new StateStore<II18nState>({});

interface IPermissionsState {
  permissions?: any;
}
export const permissionsStore = new StateStore<IPermissionsState>({});

interface IServerContextState {
  serverContext?: any;
}
export const serverContextStore = new StateStore<IServerContextState>({});

interface IPreferenceServiceState {
   preferenceService?: any;
}
export const preferenceServiceStore = new StateStore<IPreferenceServiceState>({});

interface ITokenStore {
  authToken?: string;
}
export const tokenStore = new StateStore<ITokenStore>({});

interface IUserContextStore {
  userContext?: {
    CurrentCustomer: any;
    CurrentAccount: any;
    CurrentUser: any;
  };
}
export const userContextStore = new StateStore<IUserContextStore>({});

interface ISiteMapState {
  siteMap?: any;
}
export const siteMapStore = new StateStore<ISiteMapState>({});
interface IVersionStore {
  version?: string;
  newVersion?: string;
}
const _versionStore = new StateStore<IVersionStore>({});
const { setState } = _versionStore;
_versionStore.setState = (stateChange:IVersionStore) => {
  if (_.isEmpty(_versionStore.state)) {
    _versionStore.state = stateChange;
  } else setState(stateChange);
};

export const versionStore = _versionStore;

interface ISettingsContextStore {
  settingsContext?: {
    Urls?: any;
    AccountLinkPermissionType?: number | null;
  };
}
export const settingsContextStore = new StateStore<ISettingsContextStore>({});
